module.exports = __webpack_public_path__ + "img/honda02.90f24633.png";